var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42857 13H14.0952H20.9762C21.6508 13 23 12.6364 23 11.1818C23 10.5885 22.6121 9.41445 21.0769 9.36523C21.0217 9.36346 20.9765 9.31835 20.9733 9.26321C20.8754 7.57452 18.3236 6.57489 16.7145 8.40043C16.6508 8.47271 16.5179 8.43093 16.5085 8.33502C16.384 7.06372 15.4638 5 12.4762 5C11.1428 5 8.49167 5.71032 8.42968 8.53492C8.42847 8.59014 8.38419 8.63619 8.32901 8.63846C7.49367 8.67288 6 9.14167 6 10.8182C6 11.5455 6.48571 13 8.42857 13Z",
    fill: "#737373",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85714 18H10.5238H18.619C19.4127 18 21 17.5455 21 15.7273C21 14.9833 20.5407 13.5086 18.72 13.456C18.6648 13.4544 18.6193 13.4091 18.6169 13.354C18.5236 11.2156 15.4704 9.94482 13.572 12.2911C13.5105 12.3672 13.3757 12.3258 13.3681 12.2283C13.2434 10.645 12.1781 8 8.61905 8C7.04664 8 3.91657 8.89211 3.85798 12.4438C3.85707 12.4991 3.81254 12.5453 3.75735 12.5474C2.7781 12.5842 1 13.1647 1 15.2727C1 16.1818 1.57143 18 3.85714 18Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04D);
export default __webpack_public_path__ + "static/media/04d.8df3ea10fbe9c818781f2fcafed46bac.svg";
export { ForwardRef as ReactComponent };